import React from "react";
import styled from "styled-components";
import filterString from "../filterString";

const Wrapper = styled.div`
  margin-top: 15px;
  padding: 15px;
  position: relative;
  background-color: ${(p) => p.theme.colors.primary};
  color: ${(p) => p.theme.colors.on.primary};

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -10px;
    left: 10px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${(p) => p.theme.colors.primary};
  }
`;

const HelpBox = ({ template, props, value }) => {
  return (
    <Wrapper className="sp-helpBox">
      <div
        dangerouslySetInnerHTML={{
          __html: filterString(template, props, { value }),
        }}
      />
    </Wrapper>
  );
};

export default HelpBox;
